'use client';
import { Image, type StaticImageData } from '@ssv-website/web-ui';
import right_arrow from '@/assets/icons/right_arrow.png';
import right_arrow_active from '@/assets/icons/right_arrow_active.png';
import { CosImage } from '@ssv-website/web-ui';

export interface IContainer {
  title?: string;
  subTitle?: string;
  imgUrl: string | StaticImageData;
  gradient: string;
  list: IList[];
  isMobile: boolean;
}
interface IList {
  title: string;
  text: string;
  link: string;
}

const desktop_class = {
  box: 'h-[12rem]',
  header: 'pb-[1.6rem] pl-3',
  title: 'text-[2rem]  mb-3',
  subTitle: 'text-base',
};
const mobile_class = {
  box: 'h-[4.36rem]',
  header: 'p-4',
  title: 'text-base mb-1',
  subTitle: 'text-xss',
};
export const ExploreCard = (props: IContainer) => {
  const { imgUrl, title, subTitle, list, gradient, isMobile } = props;
  const cs = isMobile ? mobile_class : desktop_class;
  return (
    <div className="overflow-hidden rounded-lg mobile:rounded-md">
      <div className={`relative cursor-pointer group ${cs.box}`}>
        <div className="absolute top-0 left-0 w-full h-full z-0 overflow-hidden">
          <Image
            src={imgUrl}
            alt=""
            className="object-fill w-full h-full transition-all duration-700 group-hover:scale-110"
            quality={100}
          />
          <div
            className={`w-full h-full absolute top-0 left-0 z-10 ${gradient}`}
          />
        </div>
        <div
          className={`flex flex-col justify-end box-border relative text-white h-full ${cs.header}`}
        >
          <div className={`font-700 ${cs.title}`}>{title}</div>
          <div className={cs.subTitle}>{subTitle}</div>
        </div>
      </div>
      <ExploreList data={list} isMobile={isMobile} />
    </div>
  );
};

const ExploreList = (props: { data: IList[]; isMobile: boolean }) => {
  const isDesktopTwoColumn = !props.isMobile && props.data.length > 3;

  return (
    <div
      className={`p-3 bg-white ${
        isDesktopTwoColumn
          ? 'grid grid-rows-3 grid-flow-col auto-cols-fr gap-3'
          : 'space-y-3'
      }`}
    >
      {props.data.map((v, i) => (
        <Item
          key={i}
          {...v}
          isMobile={props.isMobile}
          isDesktopTwoColumn={isDesktopTwoColumn}
        />
      ))}
    </div>
  );
};

const desktop_item = {
  box: 'py-3 px-4',
  title: 'text-2xl mb-1',
  text: 'text-base',
};
const mobile_item = {
  box: 'p-3 flex justify-between items-center',
  title: 'text-base mb-2',
  text: 'text-xs',
};

const Item = (
  props: IList & { isMobile: boolean; isDesktopTwoColumn?: boolean }
) => {
  const { title, text, link, isMobile, isDesktopTwoColumn } = props;
  const css = isMobile ? mobile_item : desktop_item;
  const hoverBgClass =
    isDesktopTwoColumn && !isMobile
      ? 'bg-no-repeat bg-center hover:bg-[url(../assets/images/explore_item_bg.png)] hover:bg-[length:100%_100%]'
      : 'bg-cover hover:bg-[url(../assets/images/explore_item_bg.png)]';
  const onLink = () => {
    window.location.href = link;
  };
  return (
    <div
      className={`group cursor-pointer ${hoverBgClass} ${css.box} rounded overflow-hidden`}
      onClick={onLink}
    >
      <div>
        <div className={`text-primary group-hover:font-700 ${css.title}`}>
          {title}
        </div>
        <div className={`text-describe tracking-tight font-400 ${css.text}`}>
          {text}
        </div>
      </div>
      <div>
        <CosImage
          fallbackSrc={right_arrow}
          path="/ssv-home/assets/icons/right_arrow.png"
          alt=""
          className="w-4 h-4 mt-3 group-hover:hidden"
        />
        <CosImage
          fallbackSrc={right_arrow_active}
          path="/ssv-home/assets/icons/right_arrow_active.png"
          alt=""
          className="w-4 h-4 mt-3 hidden group-hover:block"
        />
      </div>
    </div>
  );
};
